module.exports = __webpack_public_path__ + "img/valenciaextra.04f4d1a5.svg";